import type { ApplicantCreation } from 'cpool-schemas';
import type { Path } from 'react-hook-form';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import {
    type ExpenseType,
    expenseTypeConfig,
} from '~/features/leadDetails/components/Overview/CustomerData/Expenses/expenseTypeConfig.ts';
import ItemDeleteButton from '~/features/leadDetails/components/Overview/CustomerData/General/ItemDeleteButton.tsx';
import { FormCard } from '~/features/leadDetails/components/Overview/CustomerData/shared/FormCard.tsx';
import { FormCurrencyInput } from '~/features/leadDetails/components/Overview/CustomerData/shared/inputs/FormCurrencyInput';

type ExpenseItemProps = {
    index: number;
    type: ExpenseType;
    onRemove: () => void;
};

export const ExpenseItem: React.FC<ExpenseItemProps> = ({ index, onRemove, type }) => {
    const { t } = useTranslation();
    const { control } = useFormContext<ApplicantCreation>();

    return (
        <FormCard className="py-0">
            <div className="flex min-w-0 items-start gap-2">
                <div className="min-w-0 flex-1">
                    <FormCurrencyInput
                        id={`ausgaben.${type}.${index}.betragMonatlich` as Path<ApplicantCreation>}
                        control={control}
                        label={t(expenseTypeConfig[type].label)}
                        labelClassName="h-8 w-[230px] shrink-0 justify-start"
                        min={0}
                    />
                </div>
                <ItemDeleteButton iconOnly onClick={onRemove} translationPath="DELETE" />
            </div>
        </FormCard>
    );
};
